import SiteLayout from "@/components/feature/SiteLayout";
import { usePageSeo } from "@/hooks/usePageSeo";
import { getHotVideos, getLatestVideos } from "@/lib/videos";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryShortcuts from "@/pages/home/components/CategoryShortcuts";
import VideoGridSection from "@/pages/home/components/VideoGridSection";
import ThemeStrip from "@/pages/home/components/ThemeStrip";
import SiteIntro from "@/pages/home/components/SiteIntro";
import NoticeStrip from "@/pages/home/components/NoticeStrip";

export default function Home() {
  usePageSeo({
    title: "激情视频-精选激情影视与短视频合集",
    description:
      "激情视频提供丰富多样的激情影视作品和短视频内容，满足用户在线观看、欣赏不同类型激情视频的需求，内容覆盖多个热门主题。",
    keywords: "激情视频,激情影视,激情短视频,激情电影,高清视频,激情内容,影视合集,视频平台",
  });

  const latest = getLatestVideos(12);
  const hot = getHotVideos(12);

  return (
    <SiteLayout>
      <HeroCarousel />
      <div className="flex flex-col gap-12 md:gap-16 pb-4">
        <CategoryShortcuts />
        <NoticeStrip />
        <VideoGridSection
          eyebrow="New Releases"
          title="最新视频推荐"
          description="按发布时间倒序更新，刚刚上线的精选作品都在这里。"
          moreTo="/category/movie"
          moreLabel="浏览全部分类"
          videos={latest}
        />
        <ThemeStrip />
        <VideoGridSection
          eyebrow="Most Watched"
          title="热门视频精选"
          description="根据播放热度筛选，站内最受关注的 12 部作品。"
          moreTo="/category/theme"
          moreLabel="查看热门主题"
          videos={hot}
          showRank
        />
        <SiteIntro />
      </div>
    </SiteLayout>
  );
}